/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type VcdsDeploymentStateEnum = 'DISCOVERED' | 'IN_PROGRESS' | 'READY' | 'DELETED' | 'FAILED' | 'DELETION_REQUESTED' | 'DELETING' | 'DELETION_WAITING_APPROVAL' | 'DELETION_FAILED';

export const VcdsDeploymentStateEnum = {

    DISCOVERED: 'DISCOVERED' as VcdsDeploymentStateEnum,

    IN_PROGRESS: 'IN_PROGRESS' as VcdsDeploymentStateEnum,

    READY: 'READY' as VcdsDeploymentStateEnum,

    DELETED: 'DELETED' as VcdsDeploymentStateEnum,

    FAILED: 'FAILED' as VcdsDeploymentStateEnum,

    DELETION_REQUESTED: 'DELETION_REQUESTED' as VcdsDeploymentStateEnum,

    DELETING: 'DELETING' as VcdsDeploymentStateEnum,

    DELETION_WAITING_APPROVAL: 'DELETION_WAITING_APPROVAL' as VcdsDeploymentStateEnum,

    DELETION_FAILED: 'DELETION_FAILED' as VcdsDeploymentStateEnum
};

